import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/dashed-border.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-5 text-justify" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 uppercase text-left mt-5" }, "Literatur", -1)
const _hoisted_7 = { class: "list-disc list-inside mt-2 text-left" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 uppercase text-left mt-5" }, "Links", -1)
const _hoisted_11 = { class: "list-disc list-inside mt-2 text-left" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-square-up-right ml-2" }, null, -1)
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "relative my-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full h-full absolute -z-10"
}, null, -1)
const _hoisted_17 = { class: "px-12 py-14 text-left" }
const _hoisted_18 = { class: "h2 uppercase" }
const _hoisted_19 = { class: "mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", { class: "float-right mt-5" }, [
  /*#__PURE__*/_createTextVNode("Start "),
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play ml-2" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1)
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { class: "relative my-10 mt-10" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full absolute -z-10 h-full"
}, null, -1)
const _hoisted_25 = { class: "px-12 py-14 text-left" }
const _hoisted_26 = { class: "h2 uppercase" }
const _hoisted_27 = { class: "mt-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  class: "font-gradient-cta mt-5 font-black",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play mr-2 mt-5" }),
  /*#__PURE__*/_createTextVNode(" Hinweise ")
], -1)
const _hoisted_29 = ["id"]
const _hoisted_30 = {
  key: 7,
  class: "text-left list-disc ml-10 my-5"
}
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.section.type === 'text')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.section.text), 1)
      ]))
    : (_ctx.section.type === 'image')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.section.path,
            class: "my-10 mx-auto"
          }, null, 8, _hoisted_4)
        ]))
      : (_ctx.section.type === 'literature' && _ctx.section.literature.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.literature, (literature) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: literature.text
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["underline", literature.link ? 'underline' : 'no-underline pointer-events-none']),
                    href: literature.link ?? '#',
                    target: "_blank"
                  }, _toDisplayString(literature.text), 11, _hoisted_8)
                ]))
              }), 128))
            ])
          ]))
        : (_ctx.section.type === 'links' && _ctx.section.links.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.links, (link) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: link.text
                  }, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["underline", link.link ? 'underline' : 'no-underline pointer-events-none']),
                      href: link.link ?? '#',
                      target: "_blank"
                    }, _toDisplayString(link.text), 11, _hoisted_12),
                    _hoisted_13
                  ]))
                }), 128))
              ])
            ]))
          : (_ctx.section.type === 'quiz')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("section", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.section.title), 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.section.description), 1),
                    _hoisted_20,
                    _hoisted_21
                  ])
                ])
              ]))
            : (_ctx.section.type === 'lab')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("section", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.section.title), 1),
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.section.description), 1),
                      _hoisted_28
                    ])
                  ])
                ]))
              : (_ctx.section.type === 'section-header')
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 6,
                    id: _ctx.section.id,
                    class: "h2 text-left mt-10"
                  }, _toDisplayString(_ctx.section.title), 9, _hoisted_29))
                : (_ctx.section.type === 'list')
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.items, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.text,
                          class: "mt-5",
                          innerHTML: item.text
                        }, null, 8, _hoisted_31))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
}